import { render, staticRenderFns } from "./TransferField.vue?vue&type=template&id=5bf49ed3&"
import script from "./TransferField.vue?vue&type=script&lang=ts&"
export * from "./TransferField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports